import { render, staticRenderFns } from "./LearnMore.vue?vue&type=template&id=44f1defb&scoped=true"
import script from "./LearnMore.vue?vue&type=script&lang=js"
export * from "./LearnMore.vue?vue&type=script&lang=js"
import style0 from "./LearnMore.vue?vue&type=style&index=0&id=44f1defb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f1defb",
  null
  
)

export default component.exports